import { Draft, produce } from 'immer';

import {
    OrganizationsEditorAction,
    UPDATE_ORGANIZATIONS_EDITORS_DATA
} from '../actions/organizationsEditor';
import { OrganizationsDataState } from '../typings/organizations';

export const DEFAULT_ORGANIZATIONS_DATA_STATE: OrganizationsDataState = {};

export function organizationsData(
    state: OrganizationsDataState = DEFAULT_ORGANIZATIONS_DATA_STATE,
    action: OrganizationsEditorAction
): OrganizationsDataState {
    return produce(state, (draft: Draft<OrganizationsDataState>) => {
        switch (action.type) {
            case UPDATE_ORGANIZATIONS_EDITORS_DATA: {
                const { editorsOrganizations } = action;

                Object.keys(editorsOrganizations).forEach(editorKey => {
                    const organizationData = editorsOrganizations[editorKey];

                    if (organizationData && organizationData.id) {
                        draft[organizationData.id] = organizationData;
                    }
                });

                break;
            }

            default:
        }

        return draft;
    });
}
